export const siteConfig = {
  name: 'OficioYa',
  description: 'Agenda citas, organiza clientes y recibe reservas online para negocios de servicios en Colombia.',
  url: 'https://oficioya.co',
  ogImage: '/og-image-v2.webp',
  locale: 'es_CO',
};
